export default __webpack_public_path__ + "static/media/mac-privacy-location.dfefb214.png";